import firebase from 'firebase/app'
import 'firebase/analytics'

const firebaseConfig = {
  apiKey: 'AIzaSyBifW4Vo8thI6FR4nDjbMod2qind50B26U',
  authDomain: 'views-aef78.firebaseapp.com',
  databaseURL: 'https://views-aef78.firebaseio.com',
  projectId: 'views-aef78',
  storageBucket: 'views-aef78.appspot.com',
  messagingSenderId: '936185281439',
  appId: '1:936185281439:web:d4f41cfc969ea0cd6edbaa',
  measurementId: 'G-S3EJ903RDJ'
}

firebase.initializeApp(firebaseConfig)

firebase.analytics()

